import React from 'react';

interface QuotaReachedPopupProps {
  onClose: () => void;
  onConfirm: () => void; // Callback when user clicks "Okay"
}

const QuotaReachedPopup: React.FC<QuotaReachedPopupProps> = ({ onClose, onConfirm }) => {
  const handleOkay = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }} tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="modal-header border-bottom-0 pt-4 px-4">
            <div className="d-flex align-items-center">
              <div className="bg-danger bg-opacity-10 p-2 rounded-3 me-3">
                <i className="bi bi-speedometer2 text-danger fs-5"></i>
              </div>
              <h5 className="modal-title fw-bold mb-0">Quota Reached</h5>
            </div>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body px-4 pb-4">
            <p className="mb-3">You have reached your quota for Smart Cart items.</p>
            <p className="small text-muted mb-3">To continue, AI use for this item has been disabled. You can still manage it manually.</p>
            <div className="bg-light p-3 rounded-3 small">
              Need more? Contact us at <a href="mailto:contact@essentialx.us" className="text-primary text-decoration-none fw-bold">contact@essentialx.us</a>
            </div>
          </div>
          <div className="modal-footer border-top-0 px-4 pb-4 pt-0">
            <button type="button" className="btn btn-primary w-100 fw-bold py-2" onClick={handleOkay}>
              Understood
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotaReachedPopup;
